module.exports = __webpack_public_path__ + "img/sect4-22.0e9202e1.png";